import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sum'
})
export class SumPipe implements PipeTransform {
  transform(value: number, ...args: number[]) {
    return this.add(value, args == null ? null : args.reduce(this.add));
  }

  private add(n1: number, n2: number): number {
    if (n1 != null && n2 != null) {
      return Number(n1) + Number(n2);
    }
    if (n1 == null && n2 == null) {
      return null;
    }
    if (n1 != null) {
      return Number(n1);
    }
    return Number(n2);
  }
}
